import { useQuery } from "react-query";
import {
  getSubscriptionStatus,
  SubscriptionStatusData,
} from "@utils/api/subscriptionStatus";
import { queryClient } from "@utils/fetch";

function createSubscriptionQueryOptions(version: "v1" | "v2" = "v2") {
  return {
    queryFn: () => getSubscriptionStatus(version),
    queryKey: ["userSubscriptionStatus", version],
  };
}

export function useSubscriptionStatus(version: "v1" | "v2" = "v2") {
  const {
    status,
    isLoading,
    data: subscriptionStatus,
  } = useQuery(createSubscriptionQueryOptions(version));

  return { status, isLoading, subscriptionStatus };
}

export async function loadSubscriptionStatus(version: "v1" | "v2" = "v2") {
  return queryClient.fetchQuery(createSubscriptionQueryOptions(version));
}

export function getLoadedSubscriptionStatus(version: "v1" | "v2" = "v2") {
  return queryClient.getQueryData<SubscriptionStatusData>([
    "userSubscriptionStatus",
    version,
  ]);
}
